<template>
    <div>
      <hourly-annual-leave-request-approve-list></hourly-annual-leave-request-approve-list>
    </div>
  </template>
  
  <script>
  
  export default {
  }
  </script>
  
  
  